import React, {useState, useEffect} from 'react';
import ReactModal from "react-modal";

import rootCauseIcon from "../../../../../resources/images/root-cause-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";
import {FileUploadButton} from "../../../../common/button/file-upload-button/FileUploadButton";
import {FileListItem} from "../../../../common/list/file-list-item/FileListItem";
import {deleteFile} from "../../../../../services/FileService";
import {appBaseURL, downloadURL} from "../../../../../config/URLConfig";

export const ChangeIdeaTwo = ({
                                  context,
                                  setContext,
                                  navigateTo,
                                  navigateBack,
                                  toolTipsEnabled,
                                  showToaster,
                                  setSpinnerText
                              }) => {

    const [prediction, setPrediction] = useState(null);
    const [file, setFile] = useState(null);
    const [changeIdeaFileList, setChangeIdeaFileList] = useState([]);
    const [largeFileList, setLargeFileList] = useState([]);
    const [showFileSizeModal, setShowFileSizeModal] = useState(false);
    const [showDuplicateFileModal, setShowDuplicateFileModal] = useState(false);

    useEffect(() => {
        if (context.changeIdeaScreen) {
            if (context.changeIdeaScreen.prediction) {
                setPrediction(context.changeIdeaScreen.prediction);
            }

            if (context.changeIdeaScreen.changeIdeaFileList) {
                setChangeIdeaFileList([...context.changeIdeaScreen.changeIdeaFileList]);
            }
        }
    }, [context]);

    useEffect(() => {
        if (null !== file) {
            if (!changeIdeaFileList.some(fileInList => fileInList.name === file.name)) {
                setChangeIdeaFileList((prevState) => ([...prevState, file]));
            } else {
                setShowDuplicateFileModal(true);
            }
        }
    }, [file]);

    const handleNextClick = () => {
        const largeFiles = changeIdeaFileList.filter((file) => file.size > 16777216);
        if (largeFiles.length > 0) {
            setLargeFileList(largeFiles);
            setShowFileSizeModal(true);
        } else {
            setContext((prevState) => ({
                ...prevState,
                changeIdeaScreen: {
                    ...prevState.changeIdeaScreen,
                    prediction,
                    changeIdeaFileList,
                }
            }));

            if (!context.viewMode) {
                if (context.roles.includes("comprehensive-display")) {
                    navigateTo("changeIdeaThree");
                } else {
                    navigateTo("changeIdeaFour");
                }
            } else {
                if (!context.roles.includes("comprehensive-display")) {
                    navigateTo("changeIdeaFour");
                } else {
                    if (!context.changeIdeaScreen.externalReference) {
                        navigateTo("changeIdeaThree");
                    } else {
                        if (context.changeIdeaScreen.to) {
                            navigateTo("changeIdeaThree");
                        } else {
                            navigateTo("changeIdeaFour");
                        }
                    }
                }
            }
        }
    }

    const handleViewFileClick = (fileToView) => {
        window.open( appBaseURL + downloadURL + fileToView.externalReference);
    }

    const handleDeleteFileClick = async (fileToBeRemoved) => {
        if (fileToBeRemoved.externalReference) {
            const [data, error] = await deleteFile(context.username, fileToBeRemoved.externalReference);
            if (data) {
                if (data.responseStatus === "Success") {
                    let copyOfFileList = [...changeIdeaFileList];
                    let index = copyOfFileList.indexOf(fileToBeRemoved);
                    copyOfFileList.splice(index, 1);
                    setChangeIdeaFileList([...copyOfFileList]);
                }
                showToaster(data);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
        } else {
            let copyOfFileList = [...changeIdeaFileList];
            let index = copyOfFileList.indexOf(fileToBeRemoved);
            copyOfFileList.splice(index, 1);
            setChangeIdeaFileList([...copyOfFileList]);
        }
    }

    const fileListItems = changeIdeaFileList.map((file, index) => {
        return (
            <FileListItem key={index}
                          context={context}
                          text={file.name}
                          showDownloadButton={context.viewMode && file.externalReference}
                          onDownloadClick={() => {
                              handleViewFileClick(file);
                          }}
                          onDeleteClick={() => {
                              handleDeleteFileClick(file);
                          }}
            />
        );
    });

    const showPredictionField = () => {
        if (!context.viewMode) {
            return context.roles.includes("comprehensive-display");
        } else {
            if (!context.roles.includes("comprehensive-display")) {
                return false;
            } else {
                if (!context.changeIdeaScreen.externalReference) {
                    return true;
                } else {
                    return context.changeIdeaScreen.prediction;
                }
            }
        }
    }

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={rootCauseIcon} alt="Root Cause Icon" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.rootCauseScreen.name}</p>
                </div>
                <div className="wizard-right-container">
                    {showPredictionField() && <div className="input-container">
                        <div>
                            <label>Change Idea Prediction:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"ChangeIdeaPrediction123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Change Idea Prediction:"}/>}
                        </div>
                        <textarea onChange={({target}) => {
                            setPrediction(target.value);
                        }} disabled={!context.editMode} defaultValue={prediction ? prediction : null}/>
                    </div>}
                    <div className={"label-div-tooltip-"}>
                        <label className="label">Change Idea Graphic:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"ChangeIdeaGraphic123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Change Idea Graphic:"}/>}
                    </div>
                    {fileListItems}
                    <FileUploadButton buttonText={"Select File"} setFile={setFile}
                                      disableButton={changeIdeaFileList.length > 4 || !context.editMode}/>
                    {context.viewMode && context.changeIdeaScreen && context.changeIdeaScreen.externalReference &&
                    <CommentToolTip contextName={"Change Idea"} showToaster={showToaster}
                                    setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.changeIdeaScreen.externalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton disabled={showPredictionField() && !prediction} onClick={handleNextClick}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>

            <ReactModal isOpen={showFileSizeModal} className="modal-content" overlayClassName="modal-overlay">
                <div className="file-warning-modal-content">
                    <p className="modal-title">File Size Warning</p>
                    {largeFileList.length === 1 &&
                    <p className="file-warning-modal-text">
                        The following file is larger than 16MB and cannot be uploaded:
                    </p>}
                    {largeFileList.length > 1 &&
                    <p className="file-warning-modal-text">
                        The following files are larger than 16MB and cannot be uploaded:
                    </p>}
                    {largeFileList.map((file, index) => {
                        return (<p className="file-warning-modal-text" key={index}>{file.name}</p>);
                    })}
                    <div className="modal-button-container">
                        <StandardButton text="Close" onClick={() => {
                            setShowFileSizeModal(false)
                        }}/>
                    </div>
                </div>
            </ReactModal>

            <ReactModal isOpen={showDuplicateFileModal} className="modal-content" overlayClassName="modal-overlay">
                <div className="file-warning-modal-content">
                    <p className="modal-title">Duplicate File</p>
                    <p className="file-warning-modal-text">That file has already been selected</p>
                    <div className="modal-button-container">
                        <StandardButton text="Close" onClick={() => {
                            setShowDuplicateFileModal(false)
                        }}/>
                    </div>
                </div>
            </ReactModal>
        </div>
    );
}
